import { combineReducers } from "redux"
import users from "./users"
import app from "./app"

const reducers = combineReducers({
    app,
    users
})

export default reducers